/** Strip host/query noise and avoid nested /sign-in redirect loops. */
export function buildSafeRedirect(href: string): string | undefined {
  try {
    const url = new URL(href, window.location.origin)
    if (url.pathname.includes('/sign-in')) return undefined
    url.searchParams.delete('redirect')
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return undefined
  }
}

export function getDefaultHomeForRole(role?: string): string {
  if (role === 'reseller') return '/reseller'
  if (role === 'customer') return '/customer'
  if (role === 'buyer_panel') return '/buyer-panel'
  if (role === 'vendor_panel') return '/vendor-panel'
  return '/'
}

/** Prefer a saved redirect when it is safe for the authenticated role; otherwise role home. */
export function resolvePostLoginTarget(redirectTo: string | undefined, role?: string): string {
  const fallback = getDefaultHomeForRole(role)
  const safe = redirectTo ? buildSafeRedirect(redirectTo) : undefined

  if (!safe || safe === '/') return fallback

  if (role === 'customer') {
    if (safe.startsWith('/reseller') || safe.startsWith('/admin')) return fallback
  }
  if (role === 'reseller') {
    if (safe.startsWith('/customer')) return fallback
  }

  return safe
}

export function signInHrefWithRedirect(currentHref?: string): string {
  const redirect = currentHref ? buildSafeRedirect(currentHref) : undefined
  if (!redirect) return '/sign-in'
  return `/sign-in?redirect=${encodeURIComponent(redirect)}`
}
